import React, { Component } from 'react';
import config from 'react-global-configuration';

import { BrowserRouter, Redirect, Route, Link } from 'react-router-dom';

// Importação do Bootstrap
import { Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

const PropTypes = require('prop-types');

class Topo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      user: ''
    };

    this.logout = this.logout.bind(this);
  }


  componentDidMount () {
    if (localStorage.getItem("data") !== null) {
      this.setState({user: JSON.parse(localStorage.getItem("data")).email})
    } else {
      localStorage.removeItem("cid");
      this.context.router.history.push('/usuario/login');
    }
  }

  logout(e) {
    e.preventDefault();
    localStorage.removeItem("cid");
    this.context.router.history.push('/usuario/login');
  }

  render() {
    return (
      <div>
        {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
        <section id="top">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6" id="top-infs">
                Bem-vindo, {this.state.user} - <Link to={'/usuario/login'} onClick={this.logout}>Sair</Link>
              </div>
              <div className="col-xs-12 col-md-6 text-right" id="top-infs">
              </div>
            </div>
          </div>
        </section>
        <section id="header">
          <Navbar collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to={'/'}><img src={config.get('cdn') + '/images/logo1.png'} style={{width: '100%'}} alt="SIGTREIN" /></Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav>
                <NavDropdown eventKey={1} title="Cadastros" id="menu-cadastro">
                  <MenuItem header>Colaboradores</MenuItem>
                  <MenuItem href={'/colaboradores/ativos'} className="menu-links">Lista de colaboradores</MenuItem>
                  <MenuItem href={'/colaboradores/contratados'} className="menu-links">Lista de colaboradores contratados</MenuItem>
                  <MenuItem href={'/colaboradores/transferidos'} className="menu-links">Lista de colaboradores transferidos</MenuItem>
                  <MenuItem href={'/colaboradores/demitidos'} className="menu-links">Lista de colaboradores demitidos</MenuItem>
                  <MenuItem href={'/colaboradores/todos'} className="menu-links">Lista de todos os colaboradores</MenuItem>
                  <MenuItem href={'/colaboradores/designacoes'} className="menu-links">Lista de designações por colaborador</MenuItem>
                  <MenuItem href={'/funcionario/cadastrar'} className="menu-links">Cadastrar colaborador</MenuItem>
                  <MenuItem href={'/funcionario/ojts'} className="menu-links">Gerenciar OJT</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Tripulantes</MenuItem>
                  <MenuItem href={'/colaboradores/comandantes'} className="menu-links">Lista de comandantes</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Aeronaves</MenuItem>
                  <MenuItem href={'/aeronaves'} className="menu-links">Lista de aeronaves</MenuItem>
                  <MenuItem href={'/aeronave/cadastrar'} className="menu-links">Cadastrar aeronaves</MenuItem>
                  <MenuItem href={'/frotas'} className="menu-links">Lista de frotas</MenuItem>
                  <MenuItem href={'/frota/cadastrar'} className="menu-links">Cadastrar frota</MenuItem>
                  <MenuItem href={'/fabricantes'} className="menu-links">Lista de fabricantes</MenuItem>
                  <MenuItem href={'/fabricante/cadastrar'} className="menu-links">Cadastrar fabricante</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>OJTs</MenuItem>
                  <MenuItem href={'/ojts'} className="menu-links">Lista de tarefas</MenuItem>
                  <MenuItem href={'/ojt/cadastrar'} className="menu-links">Cadastrar tarefa</MenuItem>
                  <MenuItem href={'/ojts/aprovar'} className="menu-links">Aprovar OJTs pendentes</MenuItem>
                  <MenuItem href={'/funcionario/ojt/cadastrar'} className="menu-links">Cadastrar OJT como adm/avaliador</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Assinaturas</MenuItem>
                  <MenuItem href={'/assinaturas'} className="menu-links">Lista de Assinaturas</MenuItem>
                  <MenuItem href={'/assinatura/cadastrar'} className="menu-links">Cadastrar assinaturas</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Agrupamentos de certificados</MenuItem>
                  <MenuItem href={'/agrupamento/certificados'} className="menu-links">Lista de agrupamentos de certificados</MenuItem>
                  <MenuItem href={'/agrupamento/certificados/cadastrar'} className="menu-links">Cadastrar agrupamentos de certificados</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Bases</MenuItem>
                  <MenuItem href={'/bases'} className="menu-links">Lista de bases</MenuItem>
                  <MenuItem href={'/base/cadastrar'} className="menu-links">Cadastrar bases</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Cargos</MenuItem>
                  <MenuItem href={'/cargos'} className="menu-links">Lista de cargos</MenuItem>
                  <MenuItem href={'/cargo/cadastrar'} className="menu-links">Cadastrar cargos</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Funções</MenuItem>
                  <MenuItem href={'/funcoes'} className="menu-links">Lista de funções</MenuItem>
                  <MenuItem href={'/funcao/cadastrar'} className="menu-links">Cadastrar função</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Designações</MenuItem>
                  <MenuItem href={'/designacoes'} className="menu-links">Lista de designações</MenuItem>
                  <MenuItem href={'/designacao/cadastrar'} className="menu-links">Cadastrar designação</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Tarefas</MenuItem>
                  <MenuItem href={'/tarefas'} className="menu-links">Lista de tarefas</MenuItem>
                  <MenuItem href={'/tarefa/cadastrar'} className="menu-links">Cadastrar tarefa</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Afastamentos prefixados</MenuItem>
                  <MenuItem href={'/afastamentos'} className="menu-links">Lista de afastamentos</MenuItem>
                  <MenuItem href={'/afastamento/cadastrar'} className="menu-links">Cadastrar afastamento</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Referências prefixadas</MenuItem>
                  <MenuItem href={'/referencias'} className="menu-links">Lista de referências</MenuItem>
                  <MenuItem href={'/referencia/cadastrar'} className="menu-links">Cadastrar referência</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Incompatibilidades</MenuItem>
                  <MenuItem href={'/incompatibilidades'} className="menu-links">Lista de incompatibilidades</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={2} title="Controle" id="menu-cadastro">
                  <MenuItem header>Relatórios</MenuItem>
                  <MenuItem href={'/controle/pesquisa/geral'} className="menu-links">Pesquisa geral</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Controles</MenuItem>
                  {/*<MenuItem href={'/colaboradores/ativos'} className="menu-links">Avaliações</MenuItem>*/}
                  <MenuItem href={'/controle/treinamentos/nao/finalizados'} className="menu-links">Controle de treinamentos à vencer ainda não finalizados</MenuItem>
                  <MenuItem href={'/controle/designacoes/funcao'} className="menu-links">Controle de designação por funções</MenuItem>
                  <MenuItem href={'/controle/colaboradores/contratacao'} className="menu-links">Controle de colaboradores contratados sem designação</MenuItem>
                  <MenuItem href={'/controle/vencimentos/escala'} className="menu-links">Escala com Vencimentos</MenuItem>
                  <MenuItem href={'/controle/vencimentos/itens/designacao'} className="menu-links">Vencimentos de itens de designação</MenuItem>
                  <MenuItem href={'/controle/revisoes/designacoes'} className="menu-links">Revisões de designação aberta</MenuItem>
                  <MenuItem href={'/controle/frotas'} className="menu-links">Frotas</MenuItem>
                  <MenuItem href={'/controle/frotas_sem_certificados'} className="menu-links">Frotas sem certificado</MenuItem>
                  <MenuItem href={'/controle/promocoes'} className="menu-links">Histórico de promoções</MenuItem>
                  <MenuItem href={'/controle/bases'} className="menu-links">Relatório Histórico de Bases</MenuItem>
                  <MenuItem href={'/controle/habilitacoes'} className="menu-links">Habilitações</MenuItem>
                  <MenuItem href={'/controle/designacoes/pendentes'} className="menu-links">Aprovações de Revisões de Designação Pendentes</MenuItem>
                  <MenuItem href={'/controle/designacoes'} className="menu-links">Designações</MenuItem>
                  <MenuItem href={'/controle/certificados'} className="menu-links">Certificados</MenuItem>
                  <MenuItem href={'/controle/certificados/notas'} className="menu-links">Notas de certificados</MenuItem>
                  <MenuItem href={'/controle/treinamentos/realizados'} className="menu-links">Treinamentos realizados</MenuItem>
                  <MenuItem href={'/controle/treinamentos/previstos'} className="menu-links">Treinamentos previstos</MenuItem>
                  <MenuItem href={'/controle/treinamentos/certificado'} className="menu-links">Treinamentos por certificado</MenuItem>
                  <MenuItem href={'/controle/idiomas'} className="menu-links">Provas de idioma</MenuItem>
                  <MenuItem href={'/controle/cnh'} className="menu-links">CNH</MenuItem>
                  <MenuItem href={'/controle/aso'} className="menu-links">ASO</MenuItem>
                  <MenuItem href={'/colaboradores/task_cards'} className="menu-links">Task Cards</MenuItem>
                  <MenuItem href={'/controle/colaboradores/task_cards'} className="menu-links">Controle Task Cards</MenuItem>
                  <MenuItem href={'/colaboradores/frotas/revogadas'} className="menu-links">Controle Frotas Revogadas por Task Card</MenuItem>
                  {/*<MenuItem href={'/controle/cheques'} className="menu-links">Cheques</MenuItem>*/}
                  <MenuItem href={'/controle/carimbos'} className="menu-links">Carimbos</MenuItem>
                  <MenuItem href={'/controle/ojt'} className="menu-links">OJT - Modelo antigo</MenuItem>
                  <MenuItem href={'/controle/ojt/atual'} className="menu-links">OJT - Modelo atual</MenuItem>
                  <MenuItem href={'/controle/ojt/base'} className="menu-links">OJTs pendentes</MenuItem>
                  <MenuItem href={'/controle/ojt/realizado'} className="menu-links">Consulta de Tarefas de OJT realizadas</MenuItem>
                  {/* TrainingCertificationStaffs <MenuItem href={'/controle/certificados/obrigatorios'} className="menu-links">Certificados obrigatórios</MenuItem> */}
                  <MenuItem href={'/controle/certificados/arquivados'} className="menu-links">Certs. arquivados não vencidos</MenuItem>
                  {/* <MenuItem href={'/controle/frotas/obrigatorias'} className="menu-links">Frotas obrigatórias faltantes</MenuItem> */}
                  <MenuItem href={'/controle/frotas/obrigatorias/faltantes'} className="menu-links">Controle de frotas obrigatórias</MenuItem>
                  <MenuItem href={'/controle/revisao/designacao'} className="menu-links">Controle de requisitos de designação</MenuItem>
                  <MenuItem href={'/controle/filtro/certificados'} className="menu-links">{"Filtro Multiplo De Certificados"}</MenuItem>
                  <MenuItem href={'/controle/treinamentos/consolidados'} className="menu-links">Controle de treinamentos consolidados</MenuItem>
                  <MenuItem href={'/controle/certificados/vencimento'} className="menu-links">{"Vencimento De Certificados"}</MenuItem>
                  <MenuItem href={'/controle/treinamentos/funcoes'} className="menu-links">{"Treinamentos requeridos por função"}</MenuItem>
                  <MenuItem href={'/controle/treinamentos/designacoes'} className="menu-links">{"Treinamentos requeridos por item de designação"}</MenuItem>
                  <MenuItem href={'/certificados/geral'} className="menu-links">{"Lista De Certificados Geral"}</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={3} title="Escalas" id="menu-escala">
                  <MenuItem header>Escalas</MenuItem>
                  <MenuItem href={'/escalas'} className="menu-links">Lista de escalas</MenuItem>
                  <MenuItem href={'/escala/cadastrar'} className="menu-links">Cadastrar escala</MenuItem>
                  <MenuItem href={'/escala/simulacao'} className="menu-links">Simular Alteração</MenuItem>
                  <MenuItem href={'/escala/pendencias/abertas'} className="menu-links">Pendências - Não Resolvidas</MenuItem>
                  <MenuItem href={'/escala/pendencias/resolvidas'} className="menu-links">Pendências - Arquivadas</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Solicitações de Escala</MenuItem>
                  <MenuItem href={'/escala/solicitacoes'} className="menu-links">Lista de Solicitações</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Escala de fiéis</MenuItem>
                  <MenuItem href={'/escalas/base'} className="menu-links">Lista de escalas de fiéis</MenuItem>
                  <MenuItem href={'/escala/base/cadastrar'} className="menu-links">Cadastrar escala de fiéis</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Solicitação de Colaborador</MenuItem>
                  <MenuItem href={'/solicitacoes/completo'} className="menu-links">Lista de Solicitações</MenuItem>
                  <MenuItem href={'/solicitacoes/cadastrar'} className="menu-links">Cadastrar Solicitação</MenuItem>
                  <MenuItem href={'/solicitacoes/pendentes'} className="menu-links">Solicitações Pendentes</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Regimes de Trabalho</MenuItem>
                  <MenuItem href={'/regimes'} className="menu-links">Lista de Regimes de Trabalho</MenuItem>
                  <MenuItem href={'/regime/cadastrar'} className="menu-links">Cadastrar Regime de Trabalho</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Solicitações de pagamento</MenuItem>
                  <MenuItem href={'/lista/solicitacao/pagamento/deslocamento/treinamento'} className="menu-links">Deslocamento de Treinamento</MenuItem>
                  <MenuItem href={'/lista/solicitacao/pagamento/transporte/treinamento'} className="menu-links">Transporte de Treinamento</MenuItem>
                  {/* <MenuItem divider />
                  <MenuItem header>Financeiro</MenuItem>
                  <MenuItem href={'/ordem/pagamento/cadastrar'} className="menu-links">Criar ordem de pagamento</MenuItem>
                  <MenuItem href={'/ordens/pagamentos/abertas'} className="menu-links">Lista de OP abertas</MenuItem>
                  <MenuItem href={'/ordens/pagamentos/enviadas'} className="menu-links">Lista de OP enviadas</MenuItem>
                  <MenuItem href={'/escala/pagamentos/abertos/horas'} className="menu-links">Lista de pagamentos em aberto - horas</MenuItem>
                  <MenuItem href={'/escala/pagamentos/abertos/diarias'} className="menu-links">Lista de pagamentos em aberto - diárias</MenuItem>
                  <MenuItem href={'/escala/pagamentos/abertos/deslocamento'} className="menu-links">Lista de pagamentos em aberto - deslocamento</MenuItem>
                  <MenuItem href={'/escala/pagamentos/abertos/transporte'} className="menu-links">Lista de pagamentos em aberto - transporte</MenuItem>
                  <MenuItem href={'/escala/pagamentos/abertos/extra'} className="menu-links">Lista de pagamentos em aberto - extra</MenuItem>
                  <MenuItem href={'/saldo/devedor'} className="menu-links">Controle de saldo devedor</MenuItem>
                  <MenuItem href={'/pagamento/valores'} className="menu-links">Valores de pagamentos</MenuItem> */}
                </NavDropdown>
                <NavDropdown eventKey={4} title="Treinamento" id="menu-treinamento">
                  <MenuItem header>Treinamentos</MenuItem>
                  <MenuItem href={'/treinamentos'} className="menu-links">Lista de treinamentos</MenuItem>
                  <MenuItem href={'/treinamento/cadastrar'} className="menu-links">Cadastrar treinamentos</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Certificados</MenuItem>
                  <MenuItem href={'/certificados'} className="menu-links">Lista de certificados</MenuItem>
                  <MenuItem href={'/certificados/defasados'} className="menu-links">Lista de certificados defasados</MenuItem>
                  <MenuItem href={'/certificado/cadastrar'} className="menu-links">Cadastrar certificados</MenuItem>
                  <MenuItem href={'/certificados/pendentes'} className="menu-links">Certificados pendentes de aprovação</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Fornecedores</MenuItem>
                  <MenuItem href={'/fornecedores'} className="menu-links">Lista de fornecedores</MenuItem>
                  <MenuItem href={'/fornecedor/cadastrar'} className="menu-links">Cadastrar fornecedores</MenuItem>
                  {/* <MenuItem divider />
                  <MenuItem header>Financeiro</MenuItem>
                  <MenuItem href={'/ordem/pagamento/cadastrar'} className="menu-links">Criar ordem de pagamento</MenuItem>
                  <MenuItem href={'/ordens/pagamentos/abertas'} className="menu-links">Lista de OP abertas</MenuItem>
                  <MenuItem href={'/ordens/pagamentos/enviadas'} className="menu-links">Lista de OP enviadas</MenuItem>
                  <MenuItem href={'/pagamentos/abertos/diarias'} className="menu-links">Lista de pagamentos em aberto - diárias</MenuItem>
                  <MenuItem href={'/pagamentos/abertos/extra'} className="menu-links">Lista de pagamentos em aberto - extras</MenuItem> */}
                </NavDropdown>
                <NavDropdown eventKey={5} title="Planejamento" id="menu-treinamento">
                  <MenuItem href={'/planejamentos'} className="menu-links">Planejamentos</MenuItem>
                  <MenuItem href={'/planejamentos/dobras'} className="menu-links">Planejamentos de dobras</MenuItem>
                  <MenuItem href={'/planejamentos/ferias'} className="menu-links">Planejamentos de férias</MenuItem>
                  <MenuItem href={'/planejamento/cadastrar'} className="menu-links">Cadastrar planejamentos</MenuItem>
                </NavDropdown>
              </Nav>
              <Nav pullRight>
                <NavDropdown eventKey={6} title={<i className="fa fa-cog fa-fw"></i>} id="menu-treinamento">
                  <MenuItem header>Usuários do sistema</MenuItem>
                  <MenuItem href={'/usuarios'} className="menu-links">Lista de usuários</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>E-mails</MenuItem>
                  <MenuItem href={'/emails'} className="menu-links">Lista de endereço de e-mails</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Importações</MenuItem>
                  <MenuItem href={'/importacoes'} className="menu-links">Importar</MenuItem>
              </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </section>
        {
          config.get('development') &&
          <section className="development" style={{padding: '20px', background: '#ffcccb', color: 'red', width: '100%', marginBottom: '20px', fontSize: '20px'}}>
            <i className="fa fa fa-warning"></i><span style={{color: 'red'}}> Atenção: Você está utilizando o ambiente de homologação </span><i className="fa fa fa-warning"></i>
          </section>
        }
      </div>
    );
  }
}

Topo.contextTypes = {
  router: React.PropTypes.object.isRequired
}


export default Topo;



// WEBPACK FOOTER //
// ./src/Components/Layout/Topo.js